<div *ngIf="params.source == 'manageDuplicateGrid'; else elseMRNTemplate">
    <input class="custom-mrn-input" style="width: 90%;max-width: 90%;"
     (click) = "clearMRN()" autocomplete="off" type="text" readonly
    maxlength="25" #mrnRef [(ngModel)]="mrnModelValue" (keydown)="editMRN($event)" (blur)="updateMRN(mrnRef.value)" matInput>
    <span matSuffix  *ngIf="isMRNUnmasked"><i  class="fas fa-eye-slash"></i></span>
    <span matSuffix *ngIf="isMRNAvailable" (click)="viewMRN()"><i  class="fa fa-eye"></i></span>
</div>
<ng-template #elseMRNTemplate>
    <mat-form-field appearance="fill" style="margin-top: -23px;">
        <span matSuffix  *ngIf="isMRNUnmasked"><i  class="fas fa-eye-slash"></i></span>
        <span matSuffix *ngIf="isMRNAvailable" (click)="viewMRN()"><i  class="fa fa-eye"></i></span>
        <input class="customFont custom-mrn-input" (click) = "clearMRN()" autocomplete="off" type="text" [readonly] = "params.source === 'patientGrid'"
        maxlength="25" #mrnRef [(ngModel)]="mrnModelValue" (keydown)="editMRN($event)" (blur)="updateMRN(mrnRef.value)" matInput>
    </mat-form-field>
</ng-template>
